<div class="modal-body">
  <label>Intercompany Diagnostics - Tax Affiliated Group</label>
  <br><br>
  <i class="fa fa-info-circle" aria-hidden="true"></i>&nbsp;
  <b>Diagnostic : Intercompany Outside own Business - Tax Affiliated Group : </b> For the below refrenced DCS Accoutn(s), allocate the amoutn by Business (es)
  <br><br>
  <div>
    <table class="table table-bordered text custom-table">
      <thead style="text-align: center">
        <tr>
          <th>Account Details</th>
          <th>Net Amount</th>
        </tr>
      </thead>
      <tbody>
        @for (item of tableData; track $index) {
<tr>
          <td>{{item.actt_dtls}}</td>
          <td style="text-align: right;">{{item.net_amount}}</td>
        </tr>
}
        <tr>
          <td><b>Total</b></td>
          <td style="text-align: right;"><b>390,928,787</b></td>
        </tr>
      </tbody>
    </table>
    <br>
  </div>
</div>
